import * as yup from "yup"
import { Paratesto } from "../../types"

export function initialValuesParatesto(
  paratesto?: Paratesto | undefined,
  defaultTipologia?: Paratesto["tipologia"],
  defaultOrdine?: Paratesto["ordine"]
) {
  if (paratesto) {
    return paratesto
  }
  return {
    edizione: undefined,
    titolo: "",
    descrizione: "",
    tipologia: defaultTipologia || "",
    categoria: "",
    testo: "",
    autori: [],
    ubicazione: "",
    ordine: defaultOrdine || 0,
    traduttore: undefined,
  }
}

export function validationSchemaParatesto(showEdizione: boolean) {
  if (showEdizione) {
    return yup.object().shape({
      edizione: yup.number().required("Campo obbligatorio"),
      descrizione: yup.string().required("Campo obbligatorio"),
      tipologia: yup.string().required("Campo obbligatorio"),
      ordine: yup.number().required("Campo obbligatorio"),
    })
  }
  return yup.object().shape({
    descrizione: yup.string().required("Campo obbligatorio"),
    tipologia: yup.string().required("Campo obbligatorio"),
    ordine: yup.number().required("Campo obbligatorio"),
  })
}
